import { DATE_TIME_FORMAT } from '@lib/constants/common'
import { formatTimeByTimezone } from '@lib/utils/date.utils'
import RescheduleModalTitle from '@components/reschedule-course-class/reschedule-modal-title'
import Button from '@components/atoms/button'
import AlertMessage from '@components/atoms/alert-message'

type Props = {
  onConfirm: () => void
  onGoBack: () => void
  lessonNumber: string | number
  lessonTitle: string
  timezone: string
  isLoading: boolean
  isTeacher: boolean
  rescheduleRequestedBy: 'student' | 'teacher' | null
  nextClassTimestampInBatchSchedule: string
}

const ConfirmNextClassTime = ({
  lessonNumber,
  lessonTitle,
  onConfirm,
  onGoBack,
  timezone,
  isLoading = false,
  isTeacher,
  rescheduleRequestedBy,
  nextClassTimestampInBatchSchedule,
}: Props) => (
  <div className="flex flex-col space-y-5">
    <RescheduleModalTitle
      lessonNumber={lessonNumber}
      lessonTitle={lessonTitle}
    />
    <p className="font-600">
      {isTeacher
        ? 'Are you sure you will take this class next time?'
        : 'Are you sure you want to attend this class next time?'}
    </p>
    <p className="px-8 py-5 bg-opacity-50 rounded-lg bg-blue-50">
      <span className="font-600">New Date &amp; time:</span>{' '}
      {formatTimeByTimezone(
        nextClassTimestampInBatchSchedule,
        timezone,
        DATE_TIME_FORMAT
      )}
    </p>
    <p>
      {isTeacher
        ? 'All the future classes of this student will be shifted within the class schedule.'
        : 'All your future classes will be shifted within your ongoing schedule.'}
    </p>
    {isTeacher && rescheduleRequestedBy === 'teacher' && (
      <AlertMessage className="leading-tight">
        A penalty will be imposed if your cancellation limit has been reached.
      </AlertMessage>
    )}
    <div className="flex space-x-5">
      <Button onClick={onConfirm} loading={isLoading} disabled={isLoading}>
        Confirm rescheduling
      </Button>
      <button
        className="focus:outline-none font-500 hover:underline"
        onClick={onGoBack}
      >
        Go back
      </button>
    </div>
  </div>
)

export default ConfirmNextClassTime
